import { NgModule } from '@angular/core';
import { NgxAssistantOpacModule } from '@odilo/ngx-assistant';
import { ApiService } from '../services/api.service';
import { UserService } from '../services/user.service';
import { LocaleService } from '../services/locale.service';
import { AssistantComponent } from './assistant.component';

@NgModule({
  declarations: [AssistantComponent],
  imports: [NgxAssistantOpacModule.forRoot(ApiService, UserService, LocaleService)],
  exports: [AssistantComponent],
})
export class AssistantModule {}
